import { ActionPointInfo, Controller, IActionPointInfo, IDynamicLoader, Loader, Menu, Toolbar } from '@tencent/workbench';
import { config, MENU_CONFIGS, TOOLBAR_ITEMS } from './config';
import { CLICK_FROM } from '../../constant';
import { ILocalPlayFromBeginFeature } from './local-play-from-begin-interface';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { MenuKey } from '@src/framework/workbench/schema/menu-schema/common';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class LocalPlayFromBeginController {
    public constructor(@Loader(ILocalPlayFromBeginFeature) private loader: IDynamicLoader<ILocalPlayFromBeginFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'onClick', { clickFrom: CLICK_FROM.TOOLBAR })
    @Menu(config.id, 'onClick', { clickFrom: CLICK_FROM.TOOLBAR })
    public onClick() {
        this.feature.onClick();
    }

    @Toolbar(config.id, 'shouldDisabled')
    @Menu(config.id, 'shouldDisabled')
    public shouldDisable(@ActionPointInfo() info: IActionPointInfo): boolean {
        return this.feature.shouldDisabled(ActionType.SLIDE_PLAY);
    }
}
